import { TextAlignLeft } from '@phosphor-icons/react';

export default TextAlignLeft;
